module.exports = __webpack_public_path__ + "dist/media/logo--en.3f2444a1.svg";